/**
 * ユーザーグループ用のスクリプト
 */
 if (is_route('send_user_group.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        send_user_group_event_set();
    });
}

/**
 * ページ読み込み時のイベント設定
 */
window.send_user_group_event_set = function() {

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id'], true, function(){
            send_user_group_setting_event_set();
        });
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal');
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id'], true);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });
}
/**
 * 設定時のイベント設定
 */
window.send_user_group_setting_event_set = function()
{
    /**
     * ユーザー選択制御
     */
    var user_choice = {
        // 候補ユーザークリア
        clearBefore: function() {
            $('select.before-join').empty();
        },
        // ユーザーリセット
        clearAfter: function() {
            let after = $('select.after-join');
            let usersHidden = $('#users-hidden');
            let base = after.data('base');
            let options = '';
            let hidden = '';

            after.empty();
            usersHidden.empty();
            console.info(base);
            // 元の状態選択の時は、元に戻す
            if (base.length > 0) {
                $.each(base, function(idx, option) {
                    options += '<option value=' + option.id + '>' + option.text + '</option>';
                    hidden += '<input type="hidden" name="user_id[]" value="' + option.id + '" id="users_' + option.id + '" />';
                });
                after.append(options);
                usersHidden.append(hidden);
            }

        },
        // ユーザー候補セット
        setBefore: function(section_id) {
            let select = $('select.before-join');
            let action = $(select).data('action');
            let after = $('select.after-join');
            let base = after.data('base');

            let data = {
                'section_id': section_id,
                'exclude': base.length > 0 ? base.map((obj) => obj.id) : [],
                'onPrepend': 0,
            }
            _ajax.post(action, data, function (results) {
                user_choice.clearBefore();
                let options = '';
                $.each(results.options, function(idx, option) {
                    options += '<option value=' + option.id + '>' + option.text + '</option>';
                });

                select.append(options);
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        },
        // 追加押下
        setJoin: function(all = false) {
            let selectElements = all ? $('select.before-join').find('option:not(.d-none)') : $('select.before-join').find('option:selected');
            let options = '';
            let hidden = '';
            selectElements.each(function(){
                options += '<option value=' + $(this).val() + '>' + $(this).text() + '</option>';
                hidden += '<input type="hidden" name="user_id[]" value="' + $(this).val() + '" id="user_id_' + $(this).val() + '" />';
                $(this).remove();
            });
            $('select.after-join').append(options);
            $('#users-hidden').append(hidden);
        },
        // 削除押下
        setNotJoin: function(all = false) {
            let selectElements = all ? $('select.after-join').find('option:not(.d-none)') : $('select.after-join').find('option:selected');
            let options = '';
            selectElements.each(function(){
                options += '<option value=' + $(this).val() + '>' + $(this).text() + '</option>';
                $('#user_id_' + $(this).val()).remove();
                $(this).remove();
            });
            $('select.before-join').append(options);
        }
    }

    let section_id = $('#send_user_group-setting-modal-section_id');
    if (section_id.length > 0 && section_id.val() !== '') {
        user_choice.setBefore(section_id.val());
    }

    /*---- 営業所切替によるユーザー選択出し分け ----*/

    $(document).off('change', '#send_user_group-setting-modal-form select.section-select');
    $(document).on('change', '#send_user_group-setting-modal-form select.section-select', function () {
        // ユーザークリア
        user_choice.clearAfter();
        // 候補ユーザークリア
        user_choice.clearBefore();
        if ($(this).find('option:selected').length > 0
            && $(this).find('option:selected').val() !== '') {
            // 候補ユーザー取得
            user_choice.setBefore($(this).val());
        }
    });

    /*---- ユーザー追加 ----*/

    $(document).off('click', 'button#add');
    $(document).on('click', 'button#add', function () {
        user_choice.setJoin();
    });

    $(document).off('click', 'button#add_all');
    $(document).on('click', 'button#add_all', function () {
        user_choice.setJoin(true);
    });

    /*---- ユーザー削除 ----*/

    $(document).off('click', 'button#remove');
    $(document).on('click', 'button#remove', function () {
        user_choice.setNotJoin();
    });

    $(document).off('click', 'button#remove_all');
    $(document).on('click', 'button#remove_all', function () {
        user_choice.setNotJoin(true);
    });

}
